import NewsConfiguration from '../models/NewsConfiguration';
import axios from 'axios';
import NewsMapper from '../mappers/News.mapper';

export default class NewsService {
    public async getConfiguration(region: string): Promise<NewsConfiguration> {
        let api = axios.create({
            baseURL: ''
        });
        const data: any = await api.get('/News/ImportantNews?personaID=' + region);

        return new NewsMapper().map(data.data);
    }

    public async getContent(id: string): Promise<string> {
        let api = axios.create({
            baseURL: ''
        });
        const data: any = await api.get('/News/ImportantNewsArticle', { params: {"articleNodeGuid": id}});

        return data.data;
    }
}